import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function PatientOrCaregiver({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriPatientOrCaregiver: answers.xcopriPatientOrCaregiver }}
          onSubmit={(newAnswers) =>
            onSubmit({ ...answers, xcopriPatientOrCaregiver: newAnswers.xcopriPatientOrCaregiver })
          }
          onBack={onBack}
          title={`Are you a patient or a caregiver/family member of someone with epilepsy?`}
          keyForAnswer={`xcopriPatientOrCaregiver`}
          choices={['Patient', 'Caregiver/Family member']}
          selectOne
          showOther={false}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
